export enum ConfigFieldFormat {
  REACT_APP_GROUP_FILTER_PATTERN = '^[A-Z]+(?:_[a-zA-Z]*)*$',
}